import { IEntityCorrection, IEntityValidationError, IEntityValidationResult } from '../common';

export enum EStopCorrectionType {
  STOP_UPDATED_TYPE = 'STOP_UPDATED_TYPE',
  STOP_UPDATED_UNLOADED_WEIGHT = 'STOP_UPDATED_UNLOADED_WEIGHT',
  STOP_UPDATED_UNLOADED_PACKAGES = 'STOP_UPDATED_UNLOADED_PACKAGES',
}

// export enum EValidationErrorType {
export enum EStopValidationErrorType {
  STOPS_INVALID_DATES = 'STOPS_INVALID_DATES',
  STOPS_INVALID_UNLOADED_VALUES = 'STOPS_INVALID_UNLOADED_VALUES',
  STOPS_INVALID_UNLOADED_TOTAL_VALUES = 'STOPS_INVALID_UNLOADED_TOTAL_VALUES',
  STOP_WITHOUT_ADDRESS = 'STOP_WITHOUT_ADDRESS',
  // INVALID_WEIGHT = 'INVALID_WEIGHT',
  // INVALID_PACKAGES = 'INVALID_PACKAGES',

  STOP_MISSING_WEIGHT = 'STOP_MISSING_WEIGHT',
  STOP_MISSING_PACKAGES = 'STOP_MISSING_PACKAGES',
  STOP_INVALID_GOODS_DESCRIPTION = 'STOP_INVALID_GOODS_DESCRIPTION',
  STOP_MISSING_UNLOADED_WEIGHT = 'STOP_MISSING_UNLOADED_WEIGHT',
  STOP_MISSING_UNLOADED_PACKAGES = 'STOP_MISSING_UNLOADED_PACKAGES',
  STOP_MISSING_UNTIL_DATE = 'STOP_MISSING_UNTIL_DATE',
  STOP_MISSING_SINCE_DATE = 'STOP_MISSING_SINCE_DATE',
  STOP_SINCE_BEFORE_NOW = 'STOP_SINCE_BEFORE_NOW',
  STOP_UNTIL_BEFORE_SINCE = 'STOP_UNTIL_BEFORE_SINCE',

  STOPS_BELOW_MINIMUM = 'STOPS_BELOW_MINIMUM',
}

export enum EStopValidationRule {
  PAST_DATES,
  WEIGHT_AND_PACKAGES,
  DESCRIPTION, // TODO implement this
  ADDRESS_POSTAL_CODE,
  ADDRESS_COMPANY_NAME,
  ADDRESS_STREET,
}

export type IStopCorrection<T = unknown> = IEntityCorrection<string, T, EStopCorrectionType>;

export type IStopValidationError = IEntityValidationError<string, EStopValidationErrorType>;

export type IStopsValidationResult = IEntityValidationResult<
  string,
  unknown,
  EStopCorrectionType,
  EStopValidationErrorType
>;
